var React = require('react');

function StarNonShadow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40 0L48.2822 9.09037L60 5.35898L62.6274 17.3726L74.641 20L70.9096 31.7178L80 40L70.9096 48.2822L74.641 60L62.6274 62.6274L60 74.641L48.2822 70.9096L40 80L31.7178 70.9096L20 74.641L17.3726 62.6274L5.35898 60L9.09037 48.2822L0 40L9.09037 31.7178L5.35898 20L17.3726 17.3726L20 5.35898L31.7178 9.09037L40 0Z","fill":"#FFEB35"}));
}

StarNonShadow.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = StarNonShadow;

StarNonShadow.default = StarNonShadow;
